import { render } from "./VUEAppContentGestioneMessaggi.vue?vue&type=template&id=268f927a"
import script from "./VUEAppContentGestioneMessaggi.vue?vue&type=script&lang=js"
export * from "./VUEAppContentGestioneMessaggi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__